import { createFileRoute, redirect } from '@tanstack/react-router';

// Bare `/actions` has no page of its own — land on Browse Catalog (the natural
// entry point). A real Actions dashboard/hub would replace this later, at which
// point this redirect becomes a component.
export const Route = createFileRoute('/_auth/_side-layout/actions/')({
  beforeLoad: () => {
    throw redirect({ to: '/actions/catalog' });
  },
});
